import React from "react";

import InternalSelectors from "./InternalSelectors";

const CompetenciesFields = ({
  competenceCount,
  competencesStore,
  grade,
  subject,
  data,
  selected,
}) => {
  const amountOfFieldsToDisplay = Array.from(
    { length: competenceCount },
    (x, i) => i
  );

  return (
    <>
      {amountOfFieldsToDisplay.map((element, index) => {
        // const {competences, capabilities, performance} = selected;
        // const currentCompetencie = competences.find((e, i) => i === index);
        // const currentCapability = capabilities.find((e, i) => i === index);
        // const currentPerformance = performance.find((e, i) => i === index);
        return (
          <React.Fragment key={`competence-${element}`}>
            <InternalSelectors
              grade={grade}
              subject={subject}
              competencesStore={competencesStore}
              data={data}
              // selectedData={
              //   selected
              //     ? {
              //         competence: currentCompetencie,
              //         capabilities: currentCapability,
              //         performance: currentPerformance
              //       }
              //     : null
              // }
            />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default CompetenciesFields;
